import { displayName } from "../emulator/saves";
import { apiRequest } from "@common/api";

// Time played per game, kept by play-api in DynamoDB. Games are keyed by their
// display name lowercased (as covers are), so copies under other file names
// add up to one total.

export interface GamePlay {
  game: string;
  name: string;
  system: string;
  seconds: number;
  lastPlayed: string;
}

export const playKey = (name: string) => displayName(name).toLowerCase();

export async function myPlaytime(): Promise<GamePlay[]> {
  return (await apiRequest("/playtime")).json();
}

/** Adds active seconds to a game's total. `keepalive` lets it finish as the page closes. */
export async function reportPlay(name: string, system: string, seconds: number, keepalive = false) {
  await apiRequest("/playtime", {
    method: "POST",
    keepalive,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ game: playKey(name), name, system, seconds }),
  });
}

/** "3h 12m", "45m", "under a minute". */
export function formatPlayed(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  if (minutes < 1) return "under a minute";
  const hours = Math.floor(minutes / 60);
  return hours ? `${hours}h ${minutes % 60}m` : `${minutes}m`;
}
